module.exports = __webpack_public_path__ + "static/media/curenetics-logo.7993ceff.png";